<mc-modal
  backdropcloseactiondisabled
  heading="Override Sales Restriction"
  fit="medium"
  dimension="medium"
  [open]="open"
  (closed)="onClosed()">
  <p>
    Container <strong>{{ equipmentNumber }}</strong> is flagged for sale at depot <strong>{{ shopLocationCode }}</strong
    >. To proceed with a repair work order, select a reason:
  </p>

  <mc-radio-group
    legend="Select override reason"
    hiddenlegend
    name="salesOverrideReason"
    [value]="selectedReason ?? ''"
    (change)="onReasonChange($event)">
    @for (reason of reasons; track reason) {
      <mc-radio [name]="'salesOverrideReason'" [value]="reason" [label]="reason" [checked]="selectedReason === reason"></mc-radio>
    }
  </mc-radio-group>

  <mc-button
    slot="secondaryAction"
    appearance="neutral"
    variant="outlined"
    dialogaction="cancel"
    (click)="onCancel()"
    (keydown.enter)="onCancel()">
    Cancel
  </mc-button>

  <mc-button
    slot="primaryAction"
    appearance="primary"
    dialogaction="ok"
    [disabled]="!selectedReason"
    (click)="onConfirm()"
    (keydown.enter)="onConfirm()">
    Confirm Override
  </mc-button>
</mc-modal>
